var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "editMeetingForm",
          staticClass: "form-wrap step-one",
          staticStyle: {
            margin: "0 20px",
            width: "380px",
            "padding-top": "5px",
          },
          attrs: {
            model: _vm.editMeetingForm,
            rules: _vm.editMeetingFormRules,
            "label-position": "top",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-col",
                { staticClass: "form-items", attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Meeting Name", prop: "Title" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "Please enter the meeting name",
                          disabled:
                            this.editContent ||
                            _vm.disableForEdit ||
                            _vm.disabled,
                          maxlength: "30",
                        },
                        model: {
                          value: _vm.editMeetingForm.Title,
                          callback: function ($$v) {
                            _vm.$set(_vm.editMeetingForm, "Title", $$v)
                          },
                          expression: "editMeetingForm.Title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { type: "flex", align: "bottom", gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "StartDate", label: "Start Time" },
                            },
                            [
                              _c("el-date-picker", {
                                staticClass: "date-picker",
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  placeholder: "Select date",
                                  "picker-options": _vm.startDatePickerOptions,
                                  editable: false,
                                  disabled:
                                    this.edit ||
                                    this.editContent ||
                                    _vm.disableForEdit ||
                                    _vm.disabled,
                                  clearable: false,
                                },
                                on: { change: _vm.onStartDateChange },
                                model: {
                                  value: _vm.editMeetingForm.StartDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editMeetingForm,
                                      "StartDate",
                                      $$v
                                    )
                                  },
                                  expression: "editMeetingForm.StartDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "StartTime" } },
                            [
                              _c("el-time-select", {
                                ref: "startTime",
                                staticClass: "time-selecter",
                                attrs: {
                                  "picker-options": _vm.startTimePickerOptions,
                                  editable: false,
                                  placeholder: "Select period",
                                  "value-format": "HH:mm",
                                  disabled:
                                    this.edit ||
                                    this.editContent ||
                                    _vm.disableForEdit ||
                                    _vm.disabled,
                                  clearable: false,
                                },
                                on: { change: _vm.onStartTimeChange },
                                model: {
                                  value: _vm.editMeetingForm.StartTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editMeetingForm,
                                      "StartTime",
                                      $$v
                                    )
                                  },
                                  expression: "editMeetingForm.StartTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-row", { staticStyle: { float: "left" } }, [
                    _vm.startTimePrompt
                      ? _c(
                          "p",
                          {
                            staticClass: "startP",
                            attrs: { visible: _vm.startTimePrompt },
                          },
                          [
                            _vm._v(
                              " The start time must be greater than current time "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "el-row",
                    {
                      staticStyle: { "margin-top": "2%" },
                      attrs: { type: "flex", align: "bottom", gutter: 10 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "End Time", prop: "EndDate" } },
                            [
                              _c("el-date-picker", {
                                staticClass: "date-picker",
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  disabled: "",
                                  editable: false,
                                  placeholder: "Select date",
                                  "picker-options": _vm.endDatePickerOptions,
                                  clearable: false,
                                },
                                model: {
                                  value: _vm.editMeetingForm.EndDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editMeetingForm,
                                      "EndDate",
                                      $$v
                                    )
                                  },
                                  expression: "editMeetingForm.EndDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "EndTime" } },
                            [
                              _c("el-time-select", {
                                ref: "endTime",
                                staticClass: "time-selecter",
                                attrs: {
                                  "picker-options": _vm.endTimePickerOptions,
                                  editable: false,
                                  placeholder: "Select period",
                                  disabled:
                                    this.edit ||
                                    this.editContent ||
                                    _vm.disableForEdit ||
                                    _vm.disabled,
                                  clearable: false,
                                },
                                model: {
                                  value: _vm.editMeetingForm.EndTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editMeetingForm,
                                      "EndTime",
                                      $$v
                                    )
                                  },
                                  expression: "editMeetingForm.EndTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-row", { staticStyle: { float: "left" } }, [
                    _vm.endTimePrompt
                      ? _c(
                          "p",
                          {
                            staticClass: "startP",
                            attrs: { visible: _vm.endTimePrompt },
                          },
                          [
                            _vm._v(
                              " The meeting time cannot be longer than 4 hours "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        float: "left",
                        width: "100%",
                        "margin-top": "3%",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "Status", label: "Status" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled: this.createStatus || _vm.disabled,
                              },
                              on: { change: _vm.validateComment },
                              model: {
                                value: _vm.editMeetingForm.Status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editMeetingForm, "Status", $$v)
                                },
                                expression: "editMeetingForm.Status",
                              },
                            },
                            _vm._l(_vm.meetingStatus, function (itemStatus) {
                              return _c("el-option", {
                                key: itemStatus.ParamID,
                                staticStyle: { "text-align": "left" },
                                attrs: {
                                  label: itemStatus.ParamValue,
                                  value: itemStatus.ParamID,
                                  disabled:
                                    itemStatus.ParamID == 6 ? true : false,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "CommentDetail", label: "Comments" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "Please fill in the comments",
                          maxlength: 100,
                          disabled: _vm.disableForEdit || _vm.disabled,
                        },
                        model: {
                          value: _vm.editMeetingForm.CommentDetail,
                          callback: function ($$v) {
                            _vm.$set(_vm.editMeetingForm, "CommentDetail", $$v)
                          },
                          expression: "editMeetingForm.CommentDetail",
                        },
                      }),
                    ],
                    1
                  ),
                  this.edit || this.editContent
                    ? _c(
                        "el-form-item",
                        { attrs: { prop: "ProdInfo", label: "Product Info" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled:
                                this.edit ||
                                this.editContent ||
                                _vm.disableForEdit ||
                                _vm.disabled,
                            },
                            model: {
                              value: _vm.editMeetingForm.ProdInfo,
                              callback: function ($$v) {
                                _vm.$set(_vm.editMeetingForm, "ProdInfo", $$v)
                              },
                              expression: "editMeetingForm.ProdInfo",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  this.edit || this.editContent
                    ? _c(
                        "el-form-item",
                        { attrs: { prop: "Source", label: "Source" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled:
                                this.edit ||
                                this.editContent ||
                                _vm.disableForEdit ||
                                _vm.disabled,
                            },
                            model: {
                              value: _vm.editMeetingForm.Source,
                              callback: function ($$v) {
                                _vm.$set(_vm.editMeetingForm, "Source", $$v)
                              },
                              expression: "editMeetingForm.Source",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  this.edit || this.editContent
                    ? _c(
                        "el-form-item",
                        { attrs: { prop: "QuestionInfo", label: "Question" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled:
                                this.edit ||
                                this.editContent ||
                                _vm.disableForEdit ||
                                _vm.disabled,
                            },
                            model: {
                              value: _vm.editMeetingForm.QuestionInfo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editMeetingForm,
                                  "QuestionInfo",
                                  $$v
                                )
                              },
                              expression: "editMeetingForm.QuestionInfo",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center", gutter: 20 } },
            [
              _c(
                "el-col",
                { staticClass: "form-items", attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "Password",
                        label: "Joining Password(optional)",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: "",
                          placeholder: "Please enter 4~6 digital password",
                        },
                        on: { input: _vm.onPassInput },
                        model: {
                          value: _vm.editMeetingForm.Password,
                          callback: function ($$v) {
                            _vm.$set(_vm.editMeetingForm, "Password", $$v)
                          },
                          expression: "editMeetingForm.Password",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center", gutter: 20 } },
            [
              _c(
                "el-col",
                { staticClass: "form-items", attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "WaitingRoom" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { disabled: _vm.disableForEdit },
                          model: {
                            value: _vm.editMeetingForm.WaitingRoom,
                            callback: function ($$v) {
                              _vm.$set(_vm.editMeetingForm, "WaitingRoom", $$v)
                            },
                            expression: "editMeetingForm.WaitingRoom",
                          },
                        },
                        [_vm._v(" Open waiting room ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "WaterPrint" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { disabled: _vm.disableForEdit },
                          model: {
                            value: _vm.editMeetingForm.WaterPrint,
                            callback: function ($$v) {
                              _vm.$set(_vm.editMeetingForm, "WaterPrint", $$v)
                            },
                            expression: "editMeetingForm.WaterPrint",
                          },
                        },
                        [_vm._v(" Turn on screen watermark ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "JoinMute" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { disabled: _vm.disableForEdit },
                          model: {
                            value: _vm.editMeetingForm.JoinMute,
                            callback: function ($$v) {
                              _vm.$set(_vm.editMeetingForm, "JoinMute", $$v)
                            },
                            expression: "editMeetingForm.JoinMute",
                          },
                        },
                        [
                          _vm._v(
                            " Automatically mute when members join a meeting "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "JoinBeforeHost" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { disabled: _vm.disableForEdit },
                          model: {
                            value: _vm.editMeetingForm.JoinBeforeHost,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.editMeetingForm,
                                "JoinBeforeHost",
                                $$v
                              )
                            },
                            expression: "editMeetingForm.JoinBeforeHost",
                          },
                        },
                        [
                          _vm._v(
                            " Allow members to join the meeting before the host enters "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-top": "28px", "text-align": "center" } },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleEdit } },
            [_vm._v(" " + _vm._s(_vm.actionLabel) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }